export default function CheckIcon({ className }: { className?: string }) {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			className={className}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46927 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96452 6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C14.585 2.25273 17.0634 3.28084 18.8913 5.10872C20.7192 6.93661 21.7473 9.41498 21.75 12ZM16.4434 9.46279C16.4057 9.37175 16.3504 9.28903 16.2806 9.21937C16.211 9.14964 16.1283 9.09432 16.0372 9.05658C15.9462 9.01884 15.8486 8.99941 15.75 8.99941C15.6514 8.99941 15.5538 9.01884 15.4628 9.05658C15.3718 9.09432 15.289 9.14964 15.2194 9.21937L10.5 13.9397L8.78063 12.2194C8.6399 12.0786 8.44903 11.9996 8.25 11.9996C8.05098 11.9996 7.86011 12.0786 7.71938 12.2194C7.57865 12.3601 7.49959 12.551 7.49959 12.75C7.49959 12.949 7.57865 13.1399 7.71938 13.2806L9.96938 15.5306C10.039 15.6004 10.1218 15.6557 10.2128 15.6934C10.3038 15.7312 10.4014 15.7506 10.5 15.7506C10.5986 15.7506 10.6962 15.7312 10.7872 15.6934C10.8783 15.6557 10.961 15.6004 11.0306 15.5306L16.2806 10.2806C16.3504 10.211 16.4057 10.1283 16.4434 10.0372C16.4812 9.94616 16.5006 9.84856 16.5006 9.75C16.5006 9.65144 16.4812 9.55384 16.4434 9.46279Z"
				fill="#96FF43"
			/>
		</svg>
	);
}
